module.exports = __webpack_public_path__ + "img/banner.77cf6420.jpg";